module.exports = require('./dist/lib/router')
